import React from 'react';
import { copperInnerOptions, copperOuterOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const CopperWeight = (props) => {
  const innersName = 'copper_inners';
  const outersName = 'copper_outers';
  const {
    onChangeParameter,
    required,
    parameters,
    groupName,
    disabled,
    labelInners,
    labelOuters,
    tooltipInners,
    tooltipOuters,
    optionsInners,
    optionsOuters,
    locked,
  } = props;

  return (
    <div className="row">
      <div className="col-6">
        <SelectComponent
          label={labelOuters}
          required={required}
          name={outersName}
          onChange={(e) => onChangeParameter(outersName, e.target.value)}
          options={optionsOuters}
          tooltip={tooltipOuters}
          selected={parameters[outersName]}
          groupName={groupName}
          disabled={disabled}
          locked={locked} />
      </div>
      <div className="col-6">
        <SelectComponent
          label={labelInners}
          required={required}
          name={innersName}
          onChange={(e) => onChangeParameter(innersName, e.target.value)}
          options={optionsInners}
          tooltip={tooltipInners}
          selected={parameters[innersName]}
          groupName={groupName}
          disabled={disabled}
          locked={locked} />
      </div>
    </div>
  );
};

CopperWeight.defaultProps = {
  optionsOuters: copperOuterOptions,
  optionsInners: copperInnerOptions,
  labelOuters: Spree.translations.parameters.copper_outers,
  labelInners: Spree.translations.parameters.copper_inners,
  tooltipOuters: Spree.helpForParameters.copper_outers,
  tooltipInners: Spree.helpForParameters.copper_inners,
};

export default CopperWeight;
